import { isEmpty } from 'lodash'

import { renderPaymentIconWithLabelByPaymentTypeNumber } from 'utils/Orders/renderPaymentIconWithLabelByPaymentTypeNumber'
import { ReactComponent as IconNoPayment } from 'assets/icons/payment/IconNoPayment.svg'

const getTransactionHistoryIconAndLabel = (transactionHistory) => {
  if (isEmpty(transactionHistory)) {
    return { icon: <IconNoPayment />, label: 'No Payment' }
  }

  const { paymentType, creditCardDetails, paymentTypeDisplayName } =
    transactionHistory

  const lastFour =
    creditCardDetails?.last4 ??
    (creditCardDetails?.accountNumberMasked ?? '').slice(-4)
  const cardName =
    creditCardDetails?.freedompayIssuerName || creditCardDetails?.issuerName

  const { icon, label } = renderPaymentIconWithLabelByPaymentTypeNumber({
    paymentType,
    cardName,
    lastFour,
    paymentTypeDisplayName,
  })

  return { icon, label }
}

const transactionHistoryItemUtils = {
  getTransactionHistoryIconAndLabel,
}

export default transactionHistoryItemUtils
